export interface StoreModel {
  id: number;
  name: string;
  address: string;
  city: string;
  state: string;
  postalCode: string;
  latitude: number;
  longitude: number;
  startDate: string; // ISO 8601 date string
  endDate?: string | null; // Optional, can be null
}

export interface StoreState {
  stores: StoreModel[]; // Array to hold all the stores
  selectedStore: StoreModel | null; // Selected store
  loading: boolean; // Flag for loading state
  error: string | null; // Error message if any
  initialized: boolean; // Flag to track if stores have been loaded at least once
}

export const initialStoreState: StoreState = {
  stores: [],
  selectedStore: null,
  loading: false,
  error: null,
  initialized: false,
};

export interface StoreDetailData {
  location: string;
  quantity: number;
  state: string;
  postalCode: string;
  latitude: number;
  longitude: number;
}

export interface StoreCardData extends StoreModel {
  employeeAvatars: string[];
  employeesCount: number;
}
